module.exports = __webpack_public_path__ + "static/fractal-d792d85709e44795bc4c4679f22ea73a.jpg";